import { render, staticRenderFns } from "./new.vue?vue&type=template&id=56c79af0&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./elementResume.scss?vue&type=style&index=0&id=56c79af0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c79af0",
  null
  
)

export default component.exports